const intro = {
  en: {
    marqueeHeader:
      "Explore all the places you can use your UnionPay card in the U.S.",
    marqueeSubhead: "Enjoy high acceptance wherever your adventures take you.",
    marqueeLook: "Look for these logos at checkout in the U.S.",
    promoCallout: "Enjoy exclusive savings while overseas",
    promoCalloutCTA: "See Your Offers",
    exploreNow: "Explore Now",
    popularRestaurants:
      "Check out popular restaurants, shops and more in the Big Apple.",
    LA: "Los Angeles",
    NY: "New York",
    westCoast: "See everything the West Coast has to offer.",
    acceptedHeader:
      "Accepted across more than 70 million places around the world",
    acceptedSub:
      "From shopping and dining to hotels and transit and so many places in between.",
    viewMap: "View Map",
  },
  es: {
    dropdown: "Find a Travel Guide",
  },
};

export default intro;
